// extracted by mini-css-extract-plugin
export default {"controls":"PageControls_controls__OWagi","addButton":"PageControls_addButton__xaJYw","title":"PageControls_title__TO893"};